export default "__VITE_ASSET__BU6wzDwx__"